export const infiniteMovieItem = (currentItem, incomingItem) => {
  return [...currentItem, ...incomingItem]
}